import { render, staticRenderFns } from "./FeedbackFormSetupPreview.vue?vue&type=template&id=94c37828&scoped=true&lang=pug&"
import script from "./FeedbackFormSetupPreview.vue?vue&type=script&lang=js&"
export * from "./FeedbackFormSetupPreview.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackFormSetupPreview.vue?vue&type=style&index=0&id=94c37828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c37828",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VCard,VIcon,VImg,VProgressCircular,VRadio,VRadioGroup,VRow,VTextField,VTextarea})
